import type { Module } from 'vuex';
import { GlobalPairExchange } from '@/types/GlobalPairExchange';
import {RootState} from "@/store";

export interface GlobalPairExchangesState {
  globalPairExchanges: GlobalPairExchange[];
}

const globalPairExchangesModule: Module<GlobalPairExchangesState, RootState> = {
  namespaced: true,

  state: (): GlobalPairExchangesState => ({
    globalPairExchanges: [],
  }),

  getters: {
    getById: (state) => (idGlobalPair: number, idExchange: number): GlobalPairExchange | undefined => {
      return state.globalPairExchanges.find(
        globalPairExchange => 
          globalPairExchange.idGlobalPair === idGlobalPair && 
          globalPairExchange.idExchange === idExchange
      );
    },
    getByGlobalPair: (state) => (idGlobalPair: number): GlobalPairExchange[] => {
      return state.globalPairExchanges.filter(
        globalPairExchange => globalPairExchange.idGlobalPair === idGlobalPair
      );
    },
  },

  mutations: {
    setGlobalPairExchanges(
      state,
      payload: { globalPairExchanges: Record<number, any> }
    ) {
      state.globalPairExchanges = Object
        .values(payload.globalPairExchanges)
        .map(raw => GlobalPairExchange.fromRaw(raw));
    },

    setGlobalPairExchangeCreate(
      state,
      payload: {
        idGlobalPair: number;
        idExchange: number;
        usage: number | null;
        timeStart?: number | null;
        lastCandle?: number | null;
      }
    ) {
      const globalPairExchange = new GlobalPairExchange(
        payload.idGlobalPair,
        payload.idExchange,
        payload.usage,
        payload.timeStart ?? null,
        payload.lastCandle ?? null,
      );
      state.globalPairExchanges.push(globalPairExchange);
    },

    setGlobalPairExchangeUpdate(
      state,
      payload: {
        idGlobalPair: number;
        idExchange: number;
        usage?: number | null;
        timeStart?: number | null;
        lastCandle?: number | null;
      }
    ) {
      const globalPairExchange = state.globalPairExchanges.find(
        globalPairExchange => globalPairExchange.idGlobalPair === payload.idGlobalPair && globalPairExchange.idExchange === payload.idExchange
      );
      if (!globalPairExchange) return;
      if (payload.usage !== undefined) globalPairExchange.usage = payload.usage;
      if (payload.timeStart !== undefined) globalPairExchange.timeStart = payload.timeStart;
      if (payload.lastCandle !== undefined) globalPairExchange.lastCandle = payload.lastCandle;
    },

    setGlobalPairExchangeDelete(
      state,
      payload: { idGlobalPair: number; idExchange: number }
    ) {
      state.globalPairExchanges = state.globalPairExchanges.filter(
        globalPairExchange => !(globalPairExchange.idGlobalPair === payload.idGlobalPair && globalPairExchange.idExchange === payload.idExchange)
      );
    },
  },

  actions: {
    wsSetGlobalPairExchanges({ commit }, payload) {
      commit('setGlobalPairExchanges', payload);
    },
    wsGlobalPairExchangeCreate({ commit }, payload) {
      commit('setGlobalPairExchangeCreate', payload);
    },
    wsGlobalPairExchangeUpdate({ commit }, payload) {
      commit('setGlobalPairExchangeUpdate', payload);
    },
    wsGlobalPairExchangeDelete({ commit }, payload) {
      commit('setGlobalPairExchangeDelete', payload);
    },
  },
};

export default globalPairExchangesModule; 